module.exports = __webpack_public_path__ + "img/index_inExam.7755d932.png";